
import { Users } from "lucide-react";

interface FilterResultsSummaryProps {
  postTypeFilter: string;
  selectedCommunity: string;
  locationFilter: string;
  filteredCount: number;
  totalCount: number;
}

export const FilterResultsSummary = ({ 
  postTypeFilter, 
  selectedCommunity, 
  locationFilter, 
  filteredCount, 
  totalCount 
}: FilterResultsSummaryProps) => {
  const hasActiveFilters = (selectedCommunity !== 'all' && selectedCommunity !== 'see-all') || locationFilter !== 'all';

  if (!hasActiveFilters) return null;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
      <div className="flex items-center space-x-2">
        <Users className="h-4 w-4 text-blue-600" />
        <p className="text-sm text-blue-800">
          Showing {filteredCount} of {totalCount} posts
          {(selectedCommunity !== 'all' && selectedCommunity !== 'see-all') && ` • Community: ${selectedCommunity}`}
          {locationFilter !== 'all' && ` • Location: ${locationFilter}`}
        </p>
      </div>
    </div>
  );
};
